import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { handLineAfter } from '../handLine';
import { itemFade } from '../motionReveal';

const sideQuests = [
  { name: 'OfficeMinutes', detail: 'Office-hours queue for classrooms', href: '/case-studies/officeminutes' },
  { name: 'Pomodoro', detail: 'A timer made for my sister', href: '/case-studies/pomodoro' },
  { name: 'ASCII spiral', detail: 'A loading page drawn in text', href: '/case-studies/ascii-art-loading' },
  { name: 'Placeholder', detail: 'Short description' },
  { name: 'Placeholder', detail: 'Short description' },
  { name: 'Placeholder', detail: 'Short description' },
];

const Section = styled(motion.section)`
  margin-top: 24px;
`;

const Title = styled.h2`
  margin: 0 0 16px;
  font-family: var(--font-serif);
  font-weight: 500;
  font-size: 24px;
  letter-spacing: -0.02em;
  line-height: 1.2;
  color: var(--text);
`;

const Grid = styled.ul`
  list-style: none;
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 2rem 1.35rem;
  margin: 0;
  padding: 0;

  @media (max-width: 960px) {
    grid-template-columns: 1fr;
    gap: 1.75rem;
  }
`;

const Placeholder = styled.div`
  display: block;
  min-width: 0;
`;

const Card = styled(Link)`
  display: block;
  min-width: 0;
  color: inherit;
  text-decoration: none;

  &:focus-visible {
    outline: 2px solid var(--text);
    outline-offset: 4px;
    border-radius: 4px;
  }
`;

const Visual = styled.div`
  aspect-ratio: 16 / 10;
  border-radius: 12px;
  background: var(--surface);
`;

const Name = styled.span`
  position: relative;
  display: block;
  width: fit-content;
  max-width: 100%;
  margin-top: 0.85rem;
  font-family: var(--font-sans);
  font-size: 18px;
  font-weight: 500;
  letter-spacing: -0.02em;
  line-height: 1.35;
  color: var(--text);

  &::after {
    ${handLineAfter}
    opacity: 0;
  }

  ${Card}:hover &::after {
    opacity: 1;
    transform: scaleY(1.2);
  }
`;

const Detail = styled.p`
  margin: 0.3rem 0 0;
  font-family: var(--font-sans);
  font-size: 16px;
  font-weight: 400;
  letter-spacing: -0.01em;
  line-height: 1.45;
  color: var(--text-muted);
`;

const SideQuests = () => (
  <Section
    aria-label="Side quests"
    initial="hidden"
    whileInView="visible"
    viewport={{ once: true, amount: 0.25 }}
    variants={itemFade}
  >
    <Title>Side quests</Title>
    <Grid>
      {sideQuests.map((quest, index) => (
        <li key={quest.href || `placeholder-${index}`}>
          {quest.href ? (
            <Card to={quest.href}>
              <Visual aria-hidden="true" />
              <Name>{quest.name}</Name>
              <Detail>{quest.detail}</Detail>
            </Card>
          ) : (
            <Placeholder>
              <Visual aria-hidden="true" />
              <Name>{quest.name}</Name>
              <Detail>{quest.detail}</Detail>
            </Placeholder>
          )}
        </li>
      ))}
    </Grid>
  </Section>
);

export default SideQuests;
